<template>
  <div class="text-sm text-gray-500">
    <p class="max-xs:flex max-xs:flex-col">
      <span>
        {{ `${t('상호명')} : ${siteStore.organizerInfo.companyName}` }}
      </span>
      <span v-if="siteStore.organizerInfo.ceoName" class="mx-1 max-xs:hidden">|</span>
      <span v-if="siteStore.organizerInfo.ceoName">
        {{ `${t('대표이사')} : ${siteStore.organizerInfo.ceoName}` }}
      </span>
    </p>
    <p>
      {{ `${t('사업자번호')} : ${format.bizNumber(siteStore.organizerInfo.bizNo)}` }}
    </p>
    <p>{{ `${t('주소')} : ${siteStore.organizerInfo.address}` }}</p>
    <p v-if="isKoreanLocale()" class="max-xs:flex max-xs:flex-col">
      <span v-if="siteStore.organizerInfo.telNo">
        {{ `TEL : ${format.telephone(siteStore.organizerInfo.telNo)}` }}
      </span>
      <span v-if="siteStore.organizerInfo.faxNo" class="mx-1 max-xs:hidden">|</span>
      <span v-if="siteStore.organizerInfo.faxNo">
        {{ `FAX : ${format.telephone(siteStore.organizerInfo.faxNo)}` }}
      </span>
    </p>
    <p v-if="isEnglishLocale() && siteStore.organizerInfo.email">
      {{ `EMAIL : ${siteStore.organizerInfo.email}` }}
    </p>
    <p class="mt-2">{{ `Copyright © 2025 ${siteStore.organizerInfo.copyright} All Rights Reserved.` }}</p>
  </div>
</template>

<script setup lang="ts">
import { useSiteStore } from '@/stores/site'
import { useI18n } from 'vue-i18n'

const siteStore = useSiteStore()
const { t } = useI18n()
</script>

<i18n lang="yaml">
ko:
  상호명: '상호명'
  대표이사: '대표이사'
  사업자번호: '사업자등록번호'
  주소: '주소'
en:
  상호명: 'Company'
  대표이사: 'CEO'
  사업자번호: 'Business certificate number'
  주소: 'Address'
</i18n>
